import ms from 'ms';
import { useCallback, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getCookie, setCookie } from '@/redux/modules/cookies';

const DEFAULT_ONE_TIME_POPOVER_COOKIE_VALUE = 'true';
const DEFAULT_ONE_TIME_POPOVER_MAX_AGE_SECONDS = Math.floor(ms('360d') / 1000);

export type UseOneTimePopoverDismissedOptions = {
    cookieValue?: string;
    maxAgeSeconds?: number;
};

export function useOneTimePopoverWasDismissed(
    cookieName: string,
    shouldShowInitially: boolean,
    options: UseOneTimePopoverDismissedOptions = {}
) {
    const {
        cookieValue = DEFAULT_ONE_TIME_POPOVER_COOKIE_VALUE,
        maxAgeSeconds = DEFAULT_ONE_TIME_POPOVER_MAX_AGE_SECONDS,
    } = options;
    const dispatch = useAppDispatch();
    const dismissed = useAppSelector((state) => getCookie(state, cookieName)) === cookieValue;
    const [showPopover, setShowPopover] = useState(shouldShowInitially && !dismissed);

    const handleDismissPopover = useCallback(() => {
        dispatch(
            setCookie({
                maxAge: maxAgeSeconds,
                name: cookieName,
                value: cookieValue,
            })
        );
        setShowPopover(false);
    }, [cookieName, cookieValue, dispatch, maxAgeSeconds]);

    return { handleDismissPopover, showPopover };
}
